module.exports = __webpack_public_path__ + "img/944.8b777c1f.jpg";